import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getAuthSession } from '../services/api';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const authSession = getAuthSession();
  const location = useLocation();

  if (!authSession || !authSession.token) {
    const isSpecialAdmin = location.pathname.startsWith('/admin');
    return <Navigate to={isSpecialAdmin ? '/admin-login' : '/login'} replace state={{ from: location }} />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(authSession.user?.role)) {
    if (authSession.user?.role === 'admin') {
      return <Navigate to="/admin-dashboard" replace />;
    }
    if (authSession.user?.role === 'physiotherapist') {
      return <Navigate to="/physio-dashboard" replace />;
    }
    return <Navigate to="/client-dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
